import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import * as actionCreators from "../../store/actions/index";
import { withRouter } from 'react-router-dom';
import { Spin, Tabs, Row, Col, Button, Drawer } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRoute } from '@fortawesome/free-solid-svg-icons';
import Header from '../../components/Header/Header';
import { useLocation } from 'react-router';
import ComplexDataLinkCard from '../../components/ComplexDataLinkCard/ComplexDataLinkCard';
import { isListNotEmpty, isNotNullOrUndefined, isNumberNotEmpty, isObjectNotEmpty, isStringNotEmpty } from '../../shared/objectUtils';
import { CanDo, CanSee } from '../../shared/entitlements/entitlements';
import QueueLoads from '../../components/QueueLoads/QueueLoads';
import { EditOutlined } from '@ant-design/icons';
import EditLane from "../../components/EditLane/EditLane";
import LoadMap from '../../components/LoadMap/LoadMap';
import LaneUtils from '../../api/utils/laneUtils';

const { TabPane } = Tabs;

const Lane = (props) => {
    //#region constants

    const fullWidth = global.window.innerWidth;

    //#endregion
    //#region props

    const id = props.match.params.id;
    const previousBreadcrumbs = isObjectNotEmpty(props.history) && isObjectNotEmpty(props.history.location) && isObjectNotEmpty(props.history.location.state) && isListNotEmpty(props.history.location.state.previousBreadcrumbs) ? props.history.location.state.previousBreadcrumbs : [];
    const previousLocation = isObjectNotEmpty(props.history) && isObjectNotEmpty(props.history.location) && isObjectNotEmpty(props.history.location.state) && isStringNotEmpty(props.history.location.state.previousPageLocation) ? props.history.location.state.previousPageLocation : { pathname: `/lanes` };
    const previousPath = isObjectNotEmpty(props.history) && isObjectNotEmpty(props.history.location) && isObjectNotEmpty(props.history.location.state) && isStringNotEmpty(props.history.location.state.previousPageLocation) ? props.history.location.state.previousPageLocation : `/lanes`;
    const previousBreadcrumbName = isObjectNotEmpty(props.history) && isObjectNotEmpty(props.history.location) && isObjectNotEmpty(props.history.location.state) && isStringNotEmpty(props.history.location.state.previousPageTitle) ? props.history.location.state.previousPageTitle : 'Lanes';

    //#endregion
    //#region useLocation

    const location = useLocation();

    //#endregion
    //#region useDispatch and useSelectors

    const dispatch = useDispatch();
    const isLoading = useSelector(state => state.lanes.isRecordLoading);
    const error = useSelector(state => state.lanes.recordError);
    const lane = useSelector(state => state.lanes.record);

    //#endregion
    //#region useStates

    const [tabKey, setTabKey] = useState('snapshot');
    const [showEditEntity, setShowEditEntity] = useState(false);

    //#endregion
    //#region toggles

    const toggleEditEntity = () => {
        setShowEditEntity(!showEditEntity);
    };

    //#endregion
    //#region tab methods

    const onTabChange = (key) => {
        props.history.replace({ ...props.location, hash: `#${key}` });
    };

    //#endregion
    //#region useMemos

    useMemo(() => {
        if (isStringNotEmpty(location.hash)) {
            setTabKey(location.hash.replace('#', ''));
        } else {
            setTabKey('snapshot');
            props.history.replace({ ...location, hash: `#snapshot` });
        }
    }, [location]);

    useMemo(() => {
        dispatch(actionCreators.fetchLane(id));
    }, [id]);

    //#endregion
    //#region displays

    let breadcrumbs = [...previousBreadcrumbs,
    {
        location: previousLocation,
        path: previousPath,
        breadcrumbName: previousBreadcrumbName,
    },
    {
        path: `/lanes/${isStringNotEmpty(id) ? id : ''}`,
        breadcrumbName: `${isObjectNotEmpty(lane) && isStringNotEmpty(lane.irisId) ? lane.irisId : ''}`,
    },
    ];

    const getStopDetails = (stopType, city, state) => {
        const stop = {
            stopType: stopType
        };
        const stopIcon = LaneUtils.getLaneStopMarkerIcon(stop);

        return (
            <div>
                <Row style={{ marginTop: 36, marginBottom: 36 }}>
                    <Col span={24}>
                        <div style={{ display: 'flex' }}>
                            <div style={{ width: 30, marginRight: 12 }}>
                                {isNotNullOrUndefined(stopIcon) ? (<img src={stopIcon} alt={LaneUtils.getLaneStopTypeDisplay(stop)} style={{ width: 30, height: 30 }} />) : null}
                            </div>
                            <div style={{ flex: 1 }}>
                                <span>{city}, {state}</span>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    };

    const editEntityComponents = (
        <Drawer
            title={"Edit Lane"}
            onClose={toggleEditEntity}
            visible={showEditEntity === true}
            bodyStyle={{ paddingBottom: 80 }}
            style={{ zIndex: 1000 }}
            width={fullWidth > 720 ? fullWidth / 2 : 360}
            destroyOnClose={true}
            closable={false}
            maskClosable={false}
        >
            <EditLane
                cancel={toggleEditEntity}
                lane={lane}
            />
        </Drawer>
    );

    //#endregion

    if (isObjectNotEmpty(lane) && lane.id === id) {
        return (
            <Spin style={{ height: '100%', width: '100%' }} size="large" spinning={isLoading === true && error === null}>
                <Header
                    title={isObjectNotEmpty(lane) && isStringNotEmpty(lane.irisId) ? lane.irisId : 'Loading...'}
                    subtitle={isObjectNotEmpty(lane) && isObjectNotEmpty(lane.trailerType) && isStringNotEmpty(lane.trailerType.description) ? 'Trailer Type: ' + lane.trailerType.description : null}
                    icon={<FontAwesomeIcon className="anticon" icon={faRoute} />}
                    breadcrumbs={breadcrumbs}
                />
                <Tabs activeKey={tabKey} onChange={onTabChange} destroyInactiveTabPane={true} tabBarStyle={{ backgroundColor: '#ffffff', paddingRight: 24, paddingLeft: 24, margin: 0 }}>
                    <TabPane tab="Snapshot" key="snapshot">
                        <div style={{ padding: 24 }}>
                            <Row gutter={[16, 16]}>
                                <Col lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }}>
                                    <ComplexDataLinkCard
                                        title="Lane Details"
                                        headStyle={{ fontSize: 14 }}
                                        data={{
                                            "Lane ID": { value: isObjectNotEmpty(lane) && isStringNotEmpty(lane.irisId) ? lane.irisId : null, dataType: 'String' },
                                            "Approx Distance": { value: isObjectNotEmpty(lane) && isNumberNotEmpty(lane.approxDistance) ? lane.approxDistance : null, dataType: 'Distance', units: isObjectNotEmpty(lane) && isStringNotEmpty(lane.approxDistanceUnit) ? lane.approxDistanceUnit : null },
                                            "Approx Transit Time": { value: isObjectNotEmpty(lane) && isNumberNotEmpty(lane.approxTransitTime) ? lane.approxTransitTime : null, dataType: 'String' },
                                            "Rate": { value: isObjectNotEmpty(lane) && isNumberNotEmpty(lane.rate) && CanDo({ staffOnly: true }) ? lane.rate : null, dataType: 'Money' },
                                            "Rate Last Updated At": { value: isObjectNotEmpty(lane) && isNumberNotEmpty(lane.rate) && CanDo({ staffOnly: true }) ? lane.rateLastUpdatedAt : null, dataType: 'MomentDateTime' }
                                        }}
                                        extra={<Button type="primary" icon={<EditOutlined />} shape='circle' onClick={toggleEditEntity} />}
                                    />
                                </Col>
                                <Col lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }}>
                                    <ComplexDataLinkCard
                                        title="Origin and Destination"
                                        headStyle={{ fontSize: 14 }}
                                        style={{ height: 'fit-content' }}
                                        children={
                                            <Row gutter={[24, 24]}>
                                                <Col span={12}>
                                                    {getStopDetails('PICK_UP', lane.originCity, lane.originState)}
                                                </Col>
                                                <Col span={12}>
                                                    {getStopDetails('DROP_OFF', lane.destinationCity, lane.destinationState)}
                                                </Col>
                                                <Col span={24}>
                                                    <LoadMap
                                                        loadId={isObjectNotEmpty(lane) ? lane.id : null}
                                                        stops={isObjectNotEmpty(lane) && isNumberNotEmpty(lane.originLongitude) && isNumberNotEmpty(lane.originLatitude) && isNumberNotEmpty(lane.destinationLongitude) && isNumberNotEmpty(lane.destinationLatitude) ? [
                                                            {
                                                                longitude: lane.originLongitude,
                                                                latitude: lane.originLatitude,
                                                                stopType: 'PICK_UP',
                                                                id: 0,
                                                                loadId: lane.id
                                                            },
                                                            {
                                                                longitude: lane.destinationLongitude,
                                                                latitude: lane.destinationLatitude,
                                                                stopType: 'DROP_OFF',
                                                                id: 1,
                                                                loadId: lane.id
                                                            }
                                                        ] : []}
                                                        containerName={isObjectNotEmpty(lane) ? `map-${lane.id}` : 'map'}
                                                        height="400px"
                                                    />
                                                </Col>
                                            </Row>
                                        }
                                    />
                                </Col>
                            </Row>
                        </div>
                    </TabPane>
                    <TabPane tab="Open Loads" key="openLoads">
                        <CanSee staffOnly={true}>
                            <div style={{ padding: 24 }}>
                                {isObjectNotEmpty(lane) ? (
                                    <QueueLoads
                                        title="Open Loads"
                                        filter={`OPEN_LANE_${lane.id}`}
                                        filterSearchParams={{
                                            sort: 'pickUpDateTime',
                                            order: 'asc',
                                            isDeleted: false,
                                            // eta: true,
                                            'laneId': lane.id
                                        }}
                                        defaultLoadStatusFilter={['CREATED', 'PENDING', 'APPROVED', 'PENDING_RATE_CONFIRMATION']}
                                        showTable={true}
                                        showActiveLoadData={true}
                                    />
                                ) : null}
                            </div>
                        </CanSee>
                    </TabPane>
                    <TabPane tab="Booked Loads" key="bookedLoads">
                        <CanSee staffOnly={true}>
                            <div style={{ padding: 24 }}>
                                {isObjectNotEmpty(lane) ? (
                                    <QueueLoads
                                        title="Booked Loads"
                                        filter={`BOOKED_LANE_${lane.id}`}
                                        filterSearchParams={{
                                            sort: 'pickUpDateTime',
                                            order: 'asc',
                                            isDeleted: false,
                                            // eta: true,
                                            'laneId': lane.id
                                        }}
                                        defaultLoadStatusFilter={['BOOKED', 'SCHEDULED']}
                                        showTable={true}
                                        showActiveLoadData={true}
                                    />
                                ) : null}
                            </div>
                        </CanSee>
                    </TabPane>
                    <TabPane tab="In Transit Loads" key="intransitLoads">
                        <CanSee staffOnly={true}>
                            <div style={{ padding: 24 }}>
                                {isObjectNotEmpty(lane) ? (
                                    <QueueLoads
                                        title="In Transit Loads"
                                        filter={`IN_TRANSIT_LANE_${lane.id}`}
                                        filterSearchParams={{
                                            sort: 'pickUpDateTime',
                                            order: 'asc',
                                            isDeleted: false,
                                            // eta: true,
                                            'laneId': lane.id
                                        }}
                                        defaultLoadStatusFilter={['IN_TRANSIT', 'AT_STOP']}
                                        showTable={true}
                                        showActiveLoadData={true}
                                    />
                                ) : null}
                            </div>
                        </CanSee>
                    </TabPane>
                    <TabPane tab="Completed Loads" key="completedLoads">
                        <CanSee staffOnly={true}>
                            <div style={{ padding: 24 }}>
                                {isObjectNotEmpty(lane) ? (
                                    <QueueLoads
                                        title="Completed Loads"
                                        filter={`COMPLETED_LANE_${lane.id}`}
                                        filterSearchParams={{
                                            sort: 'loadEndDateTime',
                                            order: 'desc',
                                            isDeleted: false,
                                            eta: false,
                                            'laneId': lane.id
                                        }}
                                        defaultLoadStatusFilter={['COMPLETED', 'REOPENED', 'CLOSED']}
                                        showTable={true}
                                    />
                                ) : null}
                            </div>
                        </CanSee>
                    </TabPane>
                </Tabs>
                {editEntityComponents}
            </Spin>
        );
    } else {
        return <Spin style={{ height: '100%', width: '100%' }} size="large" spinning={true} />;
    }
};

export default withRouter(Lane);